jQuery(document).ready(function ($) {
  $(".menu-first-ave-main-menu-container li.menu-item-has-children > a").on(
    "click",
    function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).prev().trigger("click");
    }
  );
});
